/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as PublicLoginIndexRouteImport } from './routes/_public/login/index'
import { Route as AuthedTopupIndexRouteImport } from './routes/_authed/topup/index'
import { Route as AuthedSendIndexRouteImport } from './routes/_authed/send/index'
import { Route as AuthedProfileIndexRouteImport } from './routes/_authed/profile/index'
import { Route as AuthedMovementsIndexRouteImport } from './routes/_authed/movements/index'
import { Route as AuthedKycIndexRouteImport } from './routes/_authed/kyc/index'
import { Route as AuthedConvertIndexRouteImport } from './routes/_authed/convert/index'
import { Route as AuthedCardIndexRouteImport } from './routes/_authed/card/index'
import { Route as AuthedhomeIndexRouteImport } from './routes/_authed/(home)/index'
import { Route as AuthedSendColombianBanksIndexRouteImport } from './routes/_authed/send/colombian-banks/index'
import { Route as AuthedCardDetailsUrnRouteImport } from './routes/_authed/card/details/$urn'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginIndexRoute = PublicLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedTopupIndexRoute = AuthedTopupIndexRouteImport.update({
  id: '/topup/',
  path: '/topup/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSendIndexRoute = AuthedSendIndexRouteImport.update({
  id: '/send/',
  path: '/send/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileIndexRoute = AuthedProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMovementsIndexRoute = AuthedMovementsIndexRouteImport.update({
  id: '/movements/',
  path: '/movements/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedKycIndexRoute = AuthedKycIndexRouteImport.update({
  id: '/kyc/',
  path: '/kyc/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConvertIndexRoute = AuthedConvertIndexRouteImport.update({
  id: '/convert/',
  path: '/convert/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCardIndexRoute = AuthedCardIndexRouteImport.update({
  id: '/card/',
  path: '/card/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedhomeIndexRoute = AuthedhomeIndexRouteImport.update({
  id: '/(home)/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSendColombianBanksIndexRoute =
  AuthedSendColombianBanksIndexRouteImport.update({
    id: '/send/colombian-banks/',
    path: '/send/colombian-banks/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCardDetailsUrnRoute = AuthedCardDetailsUrnRouteImport.update({
  id: '/card/details/$urn',
  path: '/card/details/$urn',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedhomeIndexRoute
  '/card/': typeof AuthedCardIndexRoute
  '/convert/': typeof AuthedConvertIndexRoute
  '/kyc/': typeof AuthedKycIndexRoute
  '/movements/': typeof AuthedMovementsIndexRoute
  '/profile/': typeof AuthedProfileIndexRoute
  '/send/': typeof AuthedSendIndexRoute
  '/topup/': typeof AuthedTopupIndexRoute
  '/login/': typeof PublicLoginIndexRoute
  '/card/details/$urn': typeof AuthedCardDetailsUrnRoute
  '/send/colombian-banks/': typeof AuthedSendColombianBanksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedhomeIndexRoute
  '/card': typeof AuthedCardIndexRoute
  '/convert': typeof AuthedConvertIndexRoute
  '/kyc': typeof AuthedKycIndexRoute
  '/movements': typeof AuthedMovementsIndexRoute
  '/profile': typeof AuthedProfileIndexRoute
  '/send': typeof AuthedSendIndexRoute
  '/topup': typeof AuthedTopupIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/card/details/$urn': typeof AuthedCardDetailsUrnRoute
  '/send/colombian-banks': typeof AuthedSendColombianBanksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authed/(home)/': typeof AuthedhomeIndexRoute
  '/_authed/card/': typeof AuthedCardIndexRoute
  '/_authed/convert/': typeof AuthedConvertIndexRoute
  '/_authed/kyc/': typeof AuthedKycIndexRoute
  '/_authed/movements/': typeof AuthedMovementsIndexRoute
  '/_authed/profile/': typeof AuthedProfileIndexRoute
  '/_authed/send/': typeof AuthedSendIndexRoute
  '/_authed/topup/': typeof AuthedTopupIndexRoute
  '/_public/login/': typeof PublicLoginIndexRoute
  '/_authed/card/details/$urn': typeof AuthedCardDetailsUrnRoute
  '/_authed/send/colombian-banks/': typeof AuthedSendColombianBanksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/card/'
    | '/convert/'
    | '/kyc/'
    | '/movements/'
    | '/profile/'
    | '/send/'
    | '/topup/'
    | '/login/'
    | '/card/details/$urn'
    | '/send/colombian-banks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/card'
    | '/convert'
    | '/kyc'
    | '/movements'
    | '/profile'
    | '/send'
    | '/topup'
    | '/login'
    | '/card/details/$urn'
    | '/send/colombian-banks'
  id:
    | '__root__'
    | '/_authed'
    | '/_public'
    | '/_authed/(home)/'
    | '/_authed/card/'
    | '/_authed/convert/'
    | '/_authed/kyc/'
    | '/_authed/movements/'
    | '/_authed/profile/'
    | '/_authed/send/'
    | '/_authed/topup/'
    | '/_public/login/'
    | '/_authed/card/details/$urn'
    | '/_authed/send/colombian-banks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof PublicLoginIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/topup/': {
      id: '/_authed/topup/'
      path: '/topup'
      fullPath: '/topup/'
      preLoaderRoute: typeof AuthedTopupIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/send/': {
      id: '/_authed/send/'
      path: '/send'
      fullPath: '/send/'
      preLoaderRoute: typeof AuthedSendIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile/': {
      id: '/_authed/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthedProfileIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/movements/': {
      id: '/_authed/movements/'
      path: '/movements'
      fullPath: '/movements/'
      preLoaderRoute: typeof AuthedMovementsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/kyc/': {
      id: '/_authed/kyc/'
      path: '/kyc'
      fullPath: '/kyc/'
      preLoaderRoute: typeof AuthedKycIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/convert/': {
      id: '/_authed/convert/'
      path: '/convert'
      fullPath: '/convert/'
      preLoaderRoute: typeof AuthedConvertIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/card/': {
      id: '/_authed/card/'
      path: '/card'
      fullPath: '/card/'
      preLoaderRoute: typeof AuthedCardIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/(home)/': {
      id: '/_authed/(home)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedhomeIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/send/colombian-banks/': {
      id: '/_authed/send/colombian-banks/'
      path: '/send/colombian-banks'
      fullPath: '/send/colombian-banks/'
      preLoaderRoute: typeof AuthedSendColombianBanksIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/card/details/$urn': {
      id: '/_authed/card/details/$urn'
      path: '/card/details/$urn'
      fullPath: '/card/details/$urn'
      preLoaderRoute: typeof AuthedCardDetailsUrnRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedhomeIndexRoute: typeof AuthedhomeIndexRoute
  AuthedCardIndexRoute: typeof AuthedCardIndexRoute
  AuthedConvertIndexRoute: typeof AuthedConvertIndexRoute
  AuthedKycIndexRoute: typeof AuthedKycIndexRoute
  AuthedMovementsIndexRoute: typeof AuthedMovementsIndexRoute
  AuthedProfileIndexRoute: typeof AuthedProfileIndexRoute
  AuthedSendIndexRoute: typeof AuthedSendIndexRoute
  AuthedTopupIndexRoute: typeof AuthedTopupIndexRoute
  AuthedCardDetailsUrnRoute: typeof AuthedCardDetailsUrnRoute
  AuthedSendColombianBanksIndexRoute: typeof AuthedSendColombianBanksIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedhomeIndexRoute: AuthedhomeIndexRoute,
  AuthedCardIndexRoute: AuthedCardIndexRoute,
  AuthedConvertIndexRoute: AuthedConvertIndexRoute,
  AuthedKycIndexRoute: AuthedKycIndexRoute,
  AuthedMovementsIndexRoute: AuthedMovementsIndexRoute,
  AuthedProfileIndexRoute: AuthedProfileIndexRoute,
  AuthedSendIndexRoute: AuthedSendIndexRoute,
  AuthedTopupIndexRoute: AuthedTopupIndexRoute,
  AuthedCardDetailsUrnRoute: AuthedCardDetailsUrnRoute,
  AuthedSendColombianBanksIndexRoute: AuthedSendColombianBanksIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PublicRouteChildren {
  PublicLoginIndexRoute: typeof PublicLoginIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginIndexRoute: PublicLoginIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
